export default {
  RETRIEVE_ACTIVITY_LOG: {
    REQUEST: "RETRIEVE_ACTIVITY_LOG.REQUEST",
    SUCCESS: "RETRIEVE_ACTIVITY_LOG.SUCCESS",
    FAILURE: "RETRIEVE_ACTIVITY_LOG.FAILURE",
  },
};
